var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.getClass,style:(("white-space: nowrap; width: " + _vm.width + "; height: " + _vm.height)),on:{"click":_vm.onClick}},[_c('loading',{class:"outline-none",attrs:{"active":_vm.getLoaderState,"height":25,"opacity":0,"color":_vm.variant === 'transparent' ||
      _vm.variant === 'secondary' ||
      _vm.variant === 'light'
        ? '#333'
        : '#fff',"loader":"bars","is-full-page":false}}),_c('div',{class:{ invisible: _vm.isLoading }},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.text)+" ")]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }